/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".heading[_ngcontent-%COMP%]{text-align:center;font-size:x-large;font-weight:500;padding-top:1%;font-family:Montserrat-Regular,sans-serif}@media (min-width:320px) and (max-width:590px){.heading[_ngcontent-%COMP%]{font-size:larger;font-weight:600;padding-top:24%;font-family:Montserrat-Regular,sans-serif;text-align:center}}\n/*# sourceMappingURL=bpg-membership.component.css.map*/"];
export { styles as styles };
